// The mail app's keyboard shortcuts, the calendar's included: the `?` dialog and the help page both list these.
export const KEY_GROUPS = [
  {
    title: 'Move around',
    keys: [
      ['j', 'Next conversation'],
      ['k', 'Previous conversation'],
      ['o', 'Open the first one'],
      ['u', 'Back to the list'],
      ['/', 'Search'],
      ['g i', 'Go to Inbox'],
      ['g s', 'Go to Starred'],
      ['g d', 'Go to Drafts'],
      ['g t', 'Go to Sent'],
      ['g a', 'Go to All mail'],
    ],
  },
  {
    title: 'Act on mail',
    keys: [
      ['r', 'Reply'],
      ['a', 'Reply all'],
      ['f', 'Forward'],
      ['s', 'Star or unstar'],
      ['shift u', 'Mark unread'],
      ['e', 'Archive (the selection, if any)'],
      ['#', 'Move to trash'],
      ['x', 'Select the open conversation'],
      ['p', 'Print the conversation'],
      ['esc', 'Clear the selection'],
      ['c', 'Compose'],
      ['?', 'The list of shortcuts'],
    ],
  },
  {
    title: 'Calendar',
    keys: [
      ['d w m y a', 'Day, week, month, year or agenda'],
      ['t', 'Today'],
      ['j n', 'Forward'],
      ['k p', 'Back'],
      ['c', 'New event'],
      ['shift w', 'The day: its name, circle and journal'],
      ['/ s', 'Search the calendar'],
      ['esc', 'Leave the search'],
    ],
  },
]

/** The groups as `{ title, keys: [{ keys, label }] }` for templates. */
export function keyGroups() {
  return KEY_GROUPS.map((group) => ({ ...group, keys: group.keys.map(([keys, label]) => ({ keys, label })) }))
}
